import React from 'react';
import Text from 'components/Text/Text';
import kateLogo from 'assets/img/kateLogo.svg';

export const HomePage: React.FC = () => {
	return (
		<div className="h-full flex flex-col items-center justify-center gap-6 p-8 bg-white-00-new">
			<img className="w-36 h-36" src={kateLogo} alt="Kate" />
			<div className="flex flex-col items-center gap-4 max-w-120">
				<Text
					translationNameSpace="global"
					translationKey="welcomeTitle"
					align="center"
					size="xl"
					weight="bold"
				/>
				<Text
					translationNameSpace="global"
					translationKey="welcomeSubtitle"
					align="center"
					size="m"
					weight="medium"
				/>
			</div>
		</div>
	);
};
